import React, { useEffect } from 'react';
import './App.css';
import RoutesApp from './RoutesApp';
import { locale, loadMessages } from 'devextreme/localization';

import '../node_modules/devextreme/dist/css/dx.light.compact.css'; 
// Tema pre setado da bibioteca. Existem outros

locale(navigator.language);    // Configurações de tradução de mensagens manual do devextreme
loadMessages({
  'pt-BR': {
    'Search': 'Pesquisa',
    'dxList-selectAll': 'Selecionar todos',
    'Cancel': 'Cancelar',
    'Select' : 'Selecione...',
    'dxCollectionWidget-noDataText': 'Sem correspondência.'
  }
});

function App() {

  return (
    <div className="app">
      <RoutesApp />
    </div>
  );
}

export default App;